import classNames from 'classnames';
import React from 'react';
import styles from './Heading.module.scss';

export type HeadingStyle = 'default' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl';
export type HeadingLevel = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
export interface HeadingProps {
	children?: React.ReactNode;
	className?: string;
	id?: string;
	headingLevel: HeadingLevel;
	style?: HeadingStyle;
}

export const Heading: React.FC<HeadingProps> = ({ children, className, id, headingLevel, style = 'default' }) =>
	React.createElement(
		headingLevel,
		{ className: classNames(styles.Heading, styles[`Heading___${style}`], className), id },
		children,
	);
